"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Mandolin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.1.343-dev.d889c8c
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const base_1 = require("../base");
/**
 * AdminApi - axios parameter creator
 * @export
 */
exports.AdminApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateCsatSurveyEntryRequestDTO} createCsatSurveyEntryRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSurveyToEvent: (createCsatSurveyEntryRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createCsatSurveyEntryRequestDTO' is not null or undefined
            if (createCsatSurveyEntryRequestDTO === null || createCsatSurveyEntryRequestDTO === undefined) {
                throw new base_1.RequiredError('createCsatSurveyEntryRequestDTO', 'Required parameter createCsatSurveyEntryRequestDTO was null or undefined when calling addSurveyToEvent.');
            }
            const localVarPath = `/admin/v1/surveys/addSurveyToEvent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof createCsatSurveyEntryRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(createCsatSurveyEntryRequestDTO !== undefined ? createCsatSurveyEntryRequestDTO : {}) : (createCsatSurveyEntryRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<UpdateIAPPriceMapDTOItem>} updateIAPPriceMapDTOItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddIAPPriceMapItem: (updateIAPPriceMapDTOItem, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updateIAPPriceMapDTOItem' is not null or undefined
            if (updateIAPPriceMapDTOItem === null || updateIAPPriceMapDTOItem === undefined) {
                throw new base_1.RequiredError('updateIAPPriceMapDTOItem', 'Required parameter updateIAPPriceMapDTOItem was null or undefined when calling adminAddIAPPriceMapItem.');
            }
            const localVarPath = `/admin/v1/eventIAPPriceMap/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof updateIAPPriceMapDTOItem !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(updateIAPPriceMapDTOItem !== undefined ? updateIAPPriceMapDTOItem : {}) : (updateIAPPriceMapDTOItem || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminApprovePreRecord: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminApprovePreRecord.');
            }
            const localVarPath = `/admin/v1/show/approvePreRecord/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {InlineObject1} inlineObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminChangeShowState: (id, inlineObject1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminChangeShowState.');
            }
            // verify required parameter 'inlineObject1' is not null or undefined
            if (inlineObject1 === null || inlineObject1 === undefined) {
                throw new base_1.RequiredError('inlineObject1', 'Required parameter inlineObject1 was null or undefined when calling adminChangeShowState.');
            }
            const localVarPath = `/admin/v1/show/changeState/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof inlineObject1 !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject1 !== undefined ? inlineObject1 : {}) : (inlineObject1 || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ICreateEventSetBody} iCreateEventSetBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateEventSet: (iCreateEventSetBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'iCreateEventSetBody' is not null or undefined
            if (iCreateEventSetBody === null || iCreateEventSetBody === undefined) {
                throw new base_1.RequiredError('iCreateEventSetBody', 'Required parameter iCreateEventSetBody was null or undefined when calling adminCreateEventSet.');
            }
            const localVarPath = `/admin/v1/eventSet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof iCreateEventSetBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(iCreateEventSetBody !== undefined ? iCreateEventSetBody : {}) : (iCreateEventSetBody || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AdminCreateEventStreamDetailsRequestDTO} adminCreateEventStreamDetailsRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateEventStreamDetails: (adminCreateEventStreamDetailsRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adminCreateEventStreamDetailsRequestDTO' is not null or undefined
            if (adminCreateEventStreamDetailsRequestDTO === null || adminCreateEventStreamDetailsRequestDTO === undefined) {
                throw new base_1.RequiredError('adminCreateEventStreamDetailsRequestDTO', 'Required parameter adminCreateEventStreamDetailsRequestDTO was null or undefined when calling adminCreateEventStreamDetails.');
            }
            const localVarPath = `/admin/v1/event/streamDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminCreateEventStreamDetailsRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminCreateEventStreamDetailsRequestDTO !== undefined ? adminCreateEventStreamDetailsRequestDTO : {}) : (adminCreateEventStreamDetailsRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateGenreRequestDTO} createGenreRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateGenre: (createGenreRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createGenreRequestDTO' is not null or undefined
            if (createGenreRequestDTO === null || createGenreRequestDTO === undefined) {
                throw new base_1.RequiredError('createGenreRequestDTO', 'Required parameter createGenreRequestDTO was null or undefined when calling adminCreateGenre.');
            }
            const localVarPath = `/admin/v1/genre`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof createGenreRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(createGenreRequestDTO !== undefined ? createGenreRequestDTO : {}) : (createGenreRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateIAPConfigRequestDTO} createIAPConfigRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateIAPConfig: (createIAPConfigRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createIAPConfigRequestDTO' is not null or undefined
            if (createIAPConfigRequestDTO === null || createIAPConfigRequestDTO === undefined) {
                throw new base_1.RequiredError('createIAPConfigRequestDTO', 'Required parameter createIAPConfigRequestDTO was null or undefined when calling adminCreateIAPConfig.');
            }
            const localVarPath = `/admin/v1/eventIAPConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof createIAPConfigRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(createIAPConfigRequestDTO !== undefined ? createIAPConfigRequestDTO : {}) : (createIAPConfigRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AdminCreateNftTokenRequestDTO} adminCreateNftTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateNftToken: (adminCreateNftTokenRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adminCreateNftTokenRequestDTO' is not null or undefined
            if (adminCreateNftTokenRequestDTO === null || adminCreateNftTokenRequestDTO === undefined) {
                throw new base_1.RequiredError('adminCreateNftTokenRequestDTO', 'Required parameter adminCreateNftTokenRequestDTO was null or undefined when calling adminCreateNftToken.');
            }
            const localVarPath = `/admin/v1/nft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminCreateNftTokenRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminCreateNftTokenRequestDTO !== undefined ? adminCreateNftTokenRequestDTO : {}) : (adminCreateNftTokenRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AdminCreateOrganizationRequestDTO} adminCreateOrganizationRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateOrganization: (adminCreateOrganizationRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adminCreateOrganizationRequestDTO' is not null or undefined
            if (adminCreateOrganizationRequestDTO === null || adminCreateOrganizationRequestDTO === undefined) {
                throw new base_1.RequiredError('adminCreateOrganizationRequestDTO', 'Required parameter adminCreateOrganizationRequestDTO was null or undefined when calling adminCreateOrganization.');
            }
            const localVarPath = `/admin/v1/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminCreateOrganizationRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminCreateOrganizationRequestDTO !== undefined ? adminCreateOrganizationRequestDTO : {}) : (adminCreateOrganizationRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AdminCreateShowRequestDTO} adminCreateShowRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateShow: (adminCreateShowRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adminCreateShowRequestDTO' is not null or undefined
            if (adminCreateShowRequestDTO === null || adminCreateShowRequestDTO === undefined) {
                throw new base_1.RequiredError('adminCreateShowRequestDTO', 'Required parameter adminCreateShowRequestDTO was null or undefined when calling adminCreateShow.');
            }
            const localVarPath = `/admin/v1/show`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminCreateShowRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminCreateShowRequestDTO !== undefined ? adminCreateShowRequestDTO : {}) : (adminCreateShowRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateVideoAssetDTO} createVideoAssetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVideoAsset: (createVideoAssetDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createVideoAssetDTO' is not null or undefined
            if (createVideoAssetDTO === null || createVideoAssetDTO === undefined) {
                throw new base_1.RequiredError('createVideoAssetDTO', 'Required parameter createVideoAssetDTO was null or undefined when calling adminCreateVideoAsset.');
            }
            const localVarPath = `/admin/v1/videoAsset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof createVideoAssetDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(createVideoAssetDTO !== undefined ? createVideoAssetDTO : {}) : (createVideoAssetDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVideoAssetUploadUrl: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/videoAsset/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteEventStreamDetails: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminDeleteEventStreamDetails.');
            }
            const localVarPath = `/admin/v1/event/streamDetails/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteGenre: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminDeleteGenre.');
            }
            const localVarPath = `/admin/v1/genre/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteIAPConfig: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminDeleteIAPConfig.');
            }
            const localVarPath = `/admin/v1/eventIAPConfig/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteNftToken: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminDeleteNftToken.');
            }
            const localVarPath = `/admin/v1/nft/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteOrganization: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminDeleteOrganization.');
            }
            const localVarPath = `/admin/v1/organization/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteShow: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminDeleteShow.');
            }
            const localVarPath = `/admin/v1/show/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteVideoAsset: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminDeleteVideoAsset.');
            }
            const localVarPath = `/admin/v1/videoAsset/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {AdminEditShowRequestDTO} adminEditShowRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEditShow: (id, adminEditShowRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminEditShow.');
            }
            // verify required parameter 'adminEditShowRequestDTO' is not null or undefined
            if (adminEditShowRequestDTO === null || adminEditShowRequestDTO === undefined) {
                throw new base_1.RequiredError('adminEditShowRequestDTO', 'Required parameter adminEditShowRequestDTO was null or undefined when calling adminEditShow.');
            }
            const localVarPath = `/admin/v1/show/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminEditShowRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminEditShowRequestDTO !== undefined ? adminEditShowRequestDTO : {}) : (adminEditShowRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {IAddEventsBody} iAddEventsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSetAddEvents: (id, iAddEventsBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminEventSetAddEvents.');
            }
            // verify required parameter 'iAddEventsBody' is not null or undefined
            if (iAddEventsBody === null || iAddEventsBody === undefined) {
                throw new base_1.RequiredError('iAddEventsBody', 'Required parameter iAddEventsBody was null or undefined when calling adminEventSetAddEvents.');
            }
            const localVarPath = `/admin/v1/eventSet/{id}/addEvents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof iAddEventsBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(iAddEventsBody !== undefined ? iAddEventsBody : {}) : (iAddEventsBody || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {IRemoveEventsBody} iRemoveEventsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSetRemoveEvents: (id, iRemoveEventsBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminEventSetRemoveEvents.');
            }
            // verify required parameter 'iRemoveEventsBody' is not null or undefined
            if (iRemoveEventsBody === null || iRemoveEventsBody === undefined) {
                throw new base_1.RequiredError('iRemoveEventsBody', 'Required parameter iRemoveEventsBody was null or undefined when calling adminEventSetRemoveEvents.');
            }
            const localVarPath = `/admin/v1/eventSet/{id}/removeEvents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof iRemoveEventsBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(iRemoveEventsBody !== undefined ? iRemoveEventsBody : {}) : (iRemoveEventsBody || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEventSet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminGetEventSet.');
            }
            const localVarPath = `/admin/v1/eventSet/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEventStreamDetails: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminGetEventStreamDetails.');
            }
            const localVarPath = `/admin/v1/event/streamDetails/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetIAPConfig: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminGetIAPConfig.');
            }
            const localVarPath = `/admin/v1/eventIAPConfig/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetIAPPriceMap: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/eventIAPPriceMap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetOrganization: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminGetOrganization.');
            }
            const localVarPath = `/admin/v1/organization/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetShow: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminGetShow.');
            }
            const localVarPath = `/admin/v1/show/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListAppleInAppPurchaseProduct: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/appleInAppPurchaseProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {EventSetSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListEventSets: (sortBy, sortOrder, startAfter, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/eventSet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [id]
         * @param {string} [eventId]
         * @param {EventIAPSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListIAPConfig: (id, eventId, sortBy, sortOrder, startAfter, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/eventIAPConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (eventId !== undefined) {
                localVarQueryParameter['eventId'] = eventId;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {OrganizationSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {string} [name]
         * @param {string} [displayName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListOrganizations: (sortBy, sortOrder, startAfter, limit, name, displayName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (displayName !== undefined) {
                localVarQueryParameter['displayName'] = displayName;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [cobrand]
         * @param {string} [venueId]
         * @param {string} [artistId]
         * @param {string} [organizationId]
         * @param {Array<ShowType>} [type]
         * @param {string} [shopifyProductTag]
         * @param {string} [shopifyMerchTag]
         * @param {string} [muxId]
         * @param {boolean} [autoSchedule]
         * @param {Array<ShowState>} [state]
         * @param {string} [beforeDate]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {boolean} [excludePast] whether past shows should be included in the response. This parameter is incompatible with passing &#x60;sortBy&#x60; unless specific Firestore indices are created to support compound queries
         * @param {Array<AdminShowIncludes>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListShows: (cobrand, venueId, artistId, organizationId, type, shopifyProductTag, shopifyMerchTag, muxId, autoSchedule, state, beforeDate, sortBy, sortOrder, startAfter, limit, excludePast, include, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/show`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (cobrand !== undefined) {
                localVarQueryParameter['cobrand'] = cobrand;
            }
            if (venueId !== undefined) {
                localVarQueryParameter['venueId'] = venueId;
            }
            if (artistId !== undefined) {
                localVarQueryParameter['artistId'] = artistId;
            }
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (type) {
                localVarQueryParameter['type'] = type;
            }
            if (shopifyProductTag !== undefined) {
                localVarQueryParameter['shopifyProductTag'] = shopifyProductTag;
            }
            if (shopifyMerchTag !== undefined) {
                localVarQueryParameter['shopifyMerchTag'] = shopifyMerchTag;
            }
            if (muxId !== undefined) {
                localVarQueryParameter['muxId'] = muxId;
            }
            if (autoSchedule !== undefined) {
                localVarQueryParameter['autoSchedule'] = autoSchedule;
            }
            if (state) {
                localVarQueryParameter['state'] = state;
            }
            if (beforeDate !== undefined) {
                localVarQueryParameter['beforeDate'] = (beforeDate instanceof Date) ?
                    beforeDate.toISOString() :
                    beforeDate;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (excludePast !== undefined) {
                localVarQueryParameter['excludePast'] = excludePast;
            }
            if (include) {
                localVarQueryParameter['include'] = include;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [managerId]
         * @param {string} [email]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListShowsByManager: (managerId, email, startAfter, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/show/manager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (managerId !== undefined) {
                localVarQueryParameter['managerId'] = managerId;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {string} [eventId]
         * @param {string} [artistId]
         * @param {string} [venueId]
         * @param {string} [organizationId]
         * @param {string} [search]
         * @param {string} [tags]
         * @param {boolean} [videoAssetIsPublic]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListVideoAssets: (startAfter, limit, eventId, artistId, venueId, organizationId, search, tags, videoAssetIsPublic, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/videoAsset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (eventId !== undefined) {
                localVarQueryParameter['eventId'] = eventId;
            }
            if (artistId !== undefined) {
                localVarQueryParameter['artistId'] = artistId;
            }
            if (venueId !== undefined) {
                localVarQueryParameter['venueId'] = venueId;
            }
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (tags !== undefined) {
                localVarQueryParameter['tags'] = tags;
            }
            if (videoAssetIsPublic !== undefined) {
                localVarQueryParameter['videoAssetIsPublic'] = videoAssetIsPublic;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {InlineObject} inlineObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveIAPPriceMapItem: (inlineObject, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'inlineObject' is not null or undefined
            if (inlineObject === null || inlineObject === undefined) {
                throw new base_1.RequiredError('inlineObject', 'Required parameter inlineObject was null or undefined when calling adminRemoveIAPPriceMapItem.');
            }
            const localVarPath = `/admin/v1/eventIAPPriceMap/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof inlineObject !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(inlineObject !== undefined ? inlineObject : {}) : (inlineObject || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {IUpdateEventStreamDetailsUseCase} iUpdateEventStreamDetailsUseCase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateEventStreamDetails: (id, iUpdateEventStreamDetailsUseCase, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminUpdateEventStreamDetails.');
            }
            // verify required parameter 'iUpdateEventStreamDetailsUseCase' is not null or undefined
            if (iUpdateEventStreamDetailsUseCase === null || iUpdateEventStreamDetailsUseCase === undefined) {
                throw new base_1.RequiredError('iUpdateEventStreamDetailsUseCase', 'Required parameter iUpdateEventStreamDetailsUseCase was null or undefined when calling adminUpdateEventStreamDetails.');
            }
            const localVarPath = `/admin/v1/event/streamDetails/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof iUpdateEventStreamDetailsUseCase !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(iUpdateEventStreamDetailsUseCase !== undefined ? iUpdateEventStreamDetailsUseCase : {}) : (iUpdateEventStreamDetailsUseCase || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {UpdateIAPConfigRequestDTO} updateIAPConfigRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateIAPConfig: (id, updateIAPConfigRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminUpdateIAPConfig.');
            }
            // verify required parameter 'updateIAPConfigRequestDTO' is not null or undefined
            if (updateIAPConfigRequestDTO === null || updateIAPConfigRequestDTO === undefined) {
                throw new base_1.RequiredError('updateIAPConfigRequestDTO', 'Required parameter updateIAPConfigRequestDTO was null or undefined when calling adminUpdateIAPConfig.');
            }
            const localVarPath = `/admin/v1/eventIAPConfig/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof updateIAPConfigRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(updateIAPConfigRequestDTO !== undefined ? updateIAPConfigRequestDTO : {}) : (updateIAPConfigRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {AdminUpdateNftTokenRequestDTO} adminUpdateNftTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateNftToken: (id, adminUpdateNftTokenRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminUpdateNftToken.');
            }
            // verify required parameter 'adminUpdateNftTokenRequestDTO' is not null or undefined
            if (adminUpdateNftTokenRequestDTO === null || adminUpdateNftTokenRequestDTO === undefined) {
                throw new base_1.RequiredError('adminUpdateNftTokenRequestDTO', 'Required parameter adminUpdateNftTokenRequestDTO was null or undefined when calling adminUpdateNftToken.');
            }
            const localVarPath = `/admin/v1/nft/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminUpdateNftTokenRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminUpdateNftTokenRequestDTO !== undefined ? adminUpdateNftTokenRequestDTO : {}) : (adminUpdateNftTokenRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {AdminUpdateOrganizationRequestDTO} adminUpdateOrganizationRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateOrganization: (id, adminUpdateOrganizationRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling adminUpdateOrganization.');
            }
            // verify required parameter 'adminUpdateOrganizationRequestDTO' is not null or undefined
            if (adminUpdateOrganizationRequestDTO === null || adminUpdateOrganizationRequestDTO === undefined) {
                throw new base_1.RequiredError('adminUpdateOrganizationRequestDTO', 'Required parameter adminUpdateOrganizationRequestDTO was null or undefined when calling adminUpdateOrganization.');
            }
            const localVarPath = `/admin/v1/organization/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminUpdateOrganizationRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminUpdateOrganizationRequestDTO !== undefined ? adminUpdateOrganizationRequestDTO : {}) : (adminUpdateOrganizationRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UpdateVideoAssetRequest} updateVideoAssetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateVideoAsset: (updateVideoAssetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updateVideoAssetRequest' is not null or undefined
            if (updateVideoAssetRequest === null || updateVideoAssetRequest === undefined) {
                throw new base_1.RequiredError('updateVideoAssetRequest', 'Required parameter updateVideoAssetRequest was null or undefined when calling adminUpdateVideoAsset.');
            }
            const localVarPath = `/admin/v1/videoAsset/updateVideoAsset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof updateVideoAssetRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(updateVideoAssetRequest !== undefined ? updateVideoAssetRequest : {}) : (updateVideoAssetRequest || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allGenres: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/genre`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateCsatSurveyRequestDTO} createCsatSurveyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurvey: (createCsatSurveyRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createCsatSurveyRequestDTO' is not null or undefined
            if (createCsatSurveyRequestDTO === null || createCsatSurveyRequestDTO === undefined) {
                throw new base_1.RequiredError('createCsatSurveyRequestDTO', 'Required parameter createCsatSurveyRequestDTO was null or undefined when calling createSurvey.');
            }
            const localVarPath = `/admin/v1/surveys/createSurvey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof createCsatSurveyRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(createCsatSurveyRequestDTO !== undefined ? createCsatSurveyRequestDTO : {}) : (createCsatSurveyRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} surveyIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalSurveyResponsesBySurveyId: (surveyIdentifier, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'surveyIdentifier' is not null or undefined
            if (surveyIdentifier === null || surveyIdentifier === undefined) {
                throw new base_1.RequiredError('surveyIdentifier', 'Required parameter surveyIdentifier was null or undefined when calling generalSurveyResponsesBySurveyId.');
            }
            const localVarPath = `/admin/v1/generalSurveys/{surveyIdentifier}`
                .replace(`{${"surveyIdentifier"}}`, encodeURIComponent(String(surveyIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GenerateCustomTokenRequestDTO} generateCustomTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCustomToken: (generateCustomTokenRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'generateCustomTokenRequestDTO' is not null or undefined
            if (generateCustomTokenRequestDTO === null || generateCustomTokenRequestDTO === undefined) {
                throw new base_1.RequiredError('generateCustomTokenRequestDTO', 'Required parameter generateCustomTokenRequestDTO was null or undefined when calling generateCustomToken.');
            }
            const localVarPath = `/admin/v1/customToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof generateCustomTokenRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(generateCustomTokenRequestDTO !== undefined ? generateCustomTokenRequestDTO : {}) : (generateCustomTokenRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubscriptionsByTopic: (topic, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'topic' is not null or undefined
            if (topic === null || topic === undefined) {
                throw new base_1.RequiredError('topic', 'Required parameter topic was null or undefined when calling getAllSubscriptionsByTopic.');
            }
            const localVarPath = `/admin/v1/pushSubscriptions/checkForSubscriptionsForTopic/{topic}`
                .replace(`{${"topic"}}`, encodeURIComponent(String(topic)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} surveyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResponsesBySurveyId: (surveyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'surveyId' is not null or undefined
            if (surveyId === null || surveyId === undefined) {
                throw new base_1.RequiredError('surveyId', 'Required parameter surveyId was null or undefined when calling getResponsesBySurveyId.');
            }
            const localVarPath = `/admin/v1/surveys/{surveyId}`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} searchText
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpotifyArtists: (searchText, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchText' is not null or undefined
            if (searchText === null || searchText === undefined) {
                throw new base_1.RequiredError('searchText', 'Required parameter searchText was null or undefined when calling getSpotifyArtists.');
            }
            const localVarPath = `/admin/v1/spotify/artist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CobrandSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCobrands: (sortBy, sortOrder, startAfter, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/cobrand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [siteId]
         * @param {string} [slug]
         * @param {string} [surveyIdentifier]
         * @param {SortOrder} [sortOrder]
         * @param {number} [limit] Maximum value: 5000
         * @param {string} [startAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveyReponses: (siteId, slug, surveyIdentifier, sortOrder, limit, startAfter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/generalSurveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (siteId !== undefined) {
                localVarQueryParameter['siteId'] = siteId;
            }
            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }
            if (surveyIdentifier !== undefined) {
                localVarQueryParameter['surveyIdentifier'] = surveyIdentifier;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CsatSurveySortBy} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveys: (sortBy, sortOrder, startAfter, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/v1/surveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['startAfter'] = startAfter;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {MigrateApiKeyRequestDTO} migrateApiKeyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateApiKey: (migrateApiKeyRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'migrateApiKeyRequestDTO' is not null or undefined
            if (migrateApiKeyRequestDTO === null || migrateApiKeyRequestDTO === undefined) {
                throw new base_1.RequiredError('migrateApiKeyRequestDTO', 'Required parameter migrateApiKeyRequestDTO was null or undefined when calling migrateApiKey.');
            }
            const localVarPath = `/admin/v1/api-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof migrateApiKeyRequestDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(migrateApiKeyRequestDTO !== undefined ? migrateApiKeyRequestDTO : {}) : (migrateApiKeyRequestDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AdminUploadNftAssetDTO} adminUploadNftAssetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNftAsset: (adminUploadNftAssetDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'adminUploadNftAssetDTO' is not null or undefined
            if (adminUploadNftAssetDTO === null || adminUploadNftAssetDTO === undefined) {
                throw new base_1.RequiredError('adminUploadNftAssetDTO', 'Required parameter adminUploadNftAssetDTO was null or undefined when calling uploadNftAsset.');
            }
            const localVarPath = `/admin/v1/nft/assetUpload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Auth0 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken("Auth0", [])
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            // authentication firebaseAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof adminUploadNftAssetDTO !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(adminUploadNftAssetDTO !== undefined ? adminUploadNftAssetDTO : {}) : (adminUploadNftAssetDTO || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminApi - functional programming interface
 * @export
 */
exports.AdminApiFp = function (configuration) {
    return {
        /**
         *
         * @param {CreateCsatSurveyEntryRequestDTO} createCsatSurveyEntryRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSurveyToEvent(createCsatSurveyEntryRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).addSurveyToEvent(createCsatSurveyEntryRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {Array<UpdateIAPPriceMapDTOItem>} updateIAPPriceMapDTOItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddIAPPriceMapItem(updateIAPPriceMapDTOItem, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminAddIAPPriceMapItem(updateIAPPriceMapDTOItem, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminApprovePreRecord(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminApprovePreRecord(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {InlineObject1} inlineObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminChangeShowState(id, inlineObject1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminChangeShowState(id, inlineObject1, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {ICreateEventSetBody} iCreateEventSetBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateEventSet(iCreateEventSetBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminCreateEventSet(iCreateEventSetBody, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AdminCreateEventStreamDetailsRequestDTO} adminCreateEventStreamDetailsRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateEventStreamDetails(adminCreateEventStreamDetailsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminCreateEventStreamDetails(adminCreateEventStreamDetailsRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CreateGenreRequestDTO} createGenreRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateGenre(createGenreRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminCreateGenre(createGenreRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CreateIAPConfigRequestDTO} createIAPConfigRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateIAPConfig(createIAPConfigRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminCreateIAPConfig(createIAPConfigRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AdminCreateNftTokenRequestDTO} adminCreateNftTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateNftToken(adminCreateNftTokenRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminCreateNftToken(adminCreateNftTokenRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AdminCreateOrganizationRequestDTO} adminCreateOrganizationRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateOrganization(adminCreateOrganizationRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminCreateOrganization(adminCreateOrganizationRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AdminCreateShowRequestDTO} adminCreateShowRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateShow(adminCreateShowRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminCreateShow(adminCreateShowRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CreateVideoAssetDTO} createVideoAssetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVideoAsset(createVideoAssetDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminCreateVideoAsset(createVideoAssetDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVideoAssetUploadUrl(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminCreateVideoAssetUploadUrl(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteEventStreamDetails(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminDeleteEventStreamDetails(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteGenre(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminDeleteGenre(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteIAPConfig(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminDeleteIAPConfig(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteNftToken(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminDeleteNftToken(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteOrganization(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminDeleteOrganization(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteShow(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminDeleteShow(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteVideoAsset(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminDeleteVideoAsset(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {AdminEditShowRequestDTO} adminEditShowRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEditShow(id, adminEditShowRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminEditShow(id, adminEditShowRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {IAddEventsBody} iAddEventsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSetAddEvents(id, iAddEventsBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminEventSetAddEvents(id, iAddEventsBody, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {IRemoveEventsBody} iRemoveEventsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSetRemoveEvents(id, iRemoveEventsBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminEventSetRemoveEvents(id, iRemoveEventsBody, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEventSet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminGetEventSet(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEventStreamDetails(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminGetEventStreamDetails(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetIAPConfig(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminGetIAPConfig(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetIAPPriceMap(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminGetIAPPriceMap(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetOrganization(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminGetOrganization(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetShow(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminGetShow(id, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListAppleInAppPurchaseProduct(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminListAppleInAppPurchaseProduct(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {EventSetSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListEventSets(sortBy, sortOrder, startAfter, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminListEventSets(sortBy, sortOrder, startAfter, limit, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [id]
         * @param {string} [eventId]
         * @param {EventIAPSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListIAPConfig(id, eventId, sortBy, sortOrder, startAfter, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminListIAPConfig(id, eventId, sortBy, sortOrder, startAfter, limit, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {OrganizationSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {string} [name]
         * @param {string} [displayName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListOrganizations(sortBy, sortOrder, startAfter, limit, name, displayName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminListOrganizations(sortBy, sortOrder, startAfter, limit, name, displayName, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [cobrand]
         * @param {string} [venueId]
         * @param {string} [artistId]
         * @param {string} [organizationId]
         * @param {Array<ShowType>} [type]
         * @param {string} [shopifyProductTag]
         * @param {string} [shopifyMerchTag]
         * @param {string} [muxId]
         * @param {boolean} [autoSchedule]
         * @param {Array<ShowState>} [state]
         * @param {string} [beforeDate]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {boolean} [excludePast] whether past shows should be included in the response. This parameter is incompatible with passing &#x60;sortBy&#x60; unless specific Firestore indices are created to support compound queries
         * @param {Array<AdminShowIncludes>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListShows(cobrand, venueId, artistId, organizationId, type, shopifyProductTag, shopifyMerchTag, muxId, autoSchedule, state, beforeDate, sortBy, sortOrder, startAfter, limit, excludePast, include, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminListShows(cobrand, venueId, artistId, organizationId, type, shopifyProductTag, shopifyMerchTag, muxId, autoSchedule, state, beforeDate, sortBy, sortOrder, startAfter, limit, excludePast, include, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [managerId]
         * @param {string} [email]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListShowsByManager(managerId, email, startAfter, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminListShowsByManager(managerId, email, startAfter, limit, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {string} [eventId]
         * @param {string} [artistId]
         * @param {string} [venueId]
         * @param {string} [organizationId]
         * @param {string} [search]
         * @param {string} [tags]
         * @param {boolean} [videoAssetIsPublic]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListVideoAssets(startAfter, limit, eventId, artistId, venueId, organizationId, search, tags, videoAssetIsPublic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminListVideoAssets(startAfter, limit, eventId, artistId, venueId, organizationId, search, tags, videoAssetIsPublic, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {InlineObject} inlineObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveIAPPriceMapItem(inlineObject, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminRemoveIAPPriceMapItem(inlineObject, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {IUpdateEventStreamDetailsUseCase} iUpdateEventStreamDetailsUseCase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateEventStreamDetails(id, iUpdateEventStreamDetailsUseCase, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminUpdateEventStreamDetails(id, iUpdateEventStreamDetailsUseCase, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {UpdateIAPConfigRequestDTO} updateIAPConfigRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateIAPConfig(id, updateIAPConfigRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminUpdateIAPConfig(id, updateIAPConfigRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {AdminUpdateNftTokenRequestDTO} adminUpdateNftTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateNftToken(id, adminUpdateNftTokenRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminUpdateNftToken(id, adminUpdateNftTokenRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} id
         * @param {AdminUpdateOrganizationRequestDTO} adminUpdateOrganizationRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateOrganization(id, adminUpdateOrganizationRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminUpdateOrganization(id, adminUpdateOrganizationRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {UpdateVideoAssetRequest} updateVideoAssetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateVideoAsset(updateVideoAssetRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).adminUpdateVideoAsset(updateVideoAssetRequest, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allGenres(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).allGenres(options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CreateCsatSurveyRequestDTO} createCsatSurveyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurvey(createCsatSurveyRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).createSurvey(createCsatSurveyRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} surveyIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalSurveyResponsesBySurveyId(surveyIdentifier, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).generalSurveyResponsesBySurveyId(surveyIdentifier, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {GenerateCustomTokenRequestDTO} generateCustomTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCustomToken(generateCustomTokenRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).generateCustomToken(generateCustomTokenRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubscriptionsByTopic(topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).getAllSubscriptionsByTopic(topic, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} surveyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResponsesBySurveyId(surveyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).getResponsesBySurveyId(surveyId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} searchText
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpotifyArtists(searchText, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).getSpotifyArtists(searchText, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CobrandSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCobrands(sortBy, sortOrder, startAfter, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).listCobrands(sortBy, sortOrder, startAfter, limit, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {string} [siteId]
         * @param {string} [slug]
         * @param {string} [surveyIdentifier]
         * @param {SortOrder} [sortOrder]
         * @param {number} [limit] Maximum value: 5000
         * @param {string} [startAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveyReponses(siteId, slug, surveyIdentifier, sortOrder, limit, startAfter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).listSurveyReponses(siteId, slug, surveyIdentifier, sortOrder, limit, startAfter, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {CsatSurveySortBy} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveys(sortBy, sortOrder, startAfter, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).listSurveys(sortBy, sortOrder, startAfter, limit, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {MigrateApiKeyRequestDTO} migrateApiKeyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateApiKey(migrateApiKeyRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).migrateApiKey(migrateApiKeyRequestDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @param {AdminUploadNftAssetDTO} adminUploadNftAssetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNftAsset(adminUploadNftAssetDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield exports.AdminApiAxiosParamCreator(configuration).uploadNftAsset(adminUploadNftAssetDTO, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
    };
};
/**
 * AdminApi - factory interface
 * @export
 */
exports.AdminApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {CreateCsatSurveyEntryRequestDTO} createCsatSurveyEntryRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSurveyToEvent(createCsatSurveyEntryRequestDTO, options) {
            return exports.AdminApiFp(configuration).addSurveyToEvent(createCsatSurveyEntryRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<UpdateIAPPriceMapDTOItem>} updateIAPPriceMapDTOItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddIAPPriceMapItem(updateIAPPriceMapDTOItem, options) {
            return exports.AdminApiFp(configuration).adminAddIAPPriceMapItem(updateIAPPriceMapDTOItem, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminApprovePreRecord(id, options) {
            return exports.AdminApiFp(configuration).adminApprovePreRecord(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {InlineObject1} inlineObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminChangeShowState(id, inlineObject1, options) {
            return exports.AdminApiFp(configuration).adminChangeShowState(id, inlineObject1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ICreateEventSetBody} iCreateEventSetBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateEventSet(iCreateEventSetBody, options) {
            return exports.AdminApiFp(configuration).adminCreateEventSet(iCreateEventSetBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminCreateEventStreamDetailsRequestDTO} adminCreateEventStreamDetailsRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateEventStreamDetails(adminCreateEventStreamDetailsRequestDTO, options) {
            return exports.AdminApiFp(configuration).adminCreateEventStreamDetails(adminCreateEventStreamDetailsRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateGenreRequestDTO} createGenreRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateGenre(createGenreRequestDTO, options) {
            return exports.AdminApiFp(configuration).adminCreateGenre(createGenreRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateIAPConfigRequestDTO} createIAPConfigRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateIAPConfig(createIAPConfigRequestDTO, options) {
            return exports.AdminApiFp(configuration).adminCreateIAPConfig(createIAPConfigRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminCreateNftTokenRequestDTO} adminCreateNftTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateNftToken(adminCreateNftTokenRequestDTO, options) {
            return exports.AdminApiFp(configuration).adminCreateNftToken(adminCreateNftTokenRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminCreateOrganizationRequestDTO} adminCreateOrganizationRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateOrganization(adminCreateOrganizationRequestDTO, options) {
            return exports.AdminApiFp(configuration).adminCreateOrganization(adminCreateOrganizationRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminCreateShowRequestDTO} adminCreateShowRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateShow(adminCreateShowRequestDTO, options) {
            return exports.AdminApiFp(configuration).adminCreateShow(adminCreateShowRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateVideoAssetDTO} createVideoAssetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVideoAsset(createVideoAssetDTO, options) {
            return exports.AdminApiFp(configuration).adminCreateVideoAsset(createVideoAssetDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateVideoAssetUploadUrl(options) {
            return exports.AdminApiFp(configuration).adminCreateVideoAssetUploadUrl(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteEventStreamDetails(id, options) {
            return exports.AdminApiFp(configuration).adminDeleteEventStreamDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteGenre(id, options) {
            return exports.AdminApiFp(configuration).adminDeleteGenre(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteIAPConfig(id, options) {
            return exports.AdminApiFp(configuration).adminDeleteIAPConfig(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteNftToken(id, options) {
            return exports.AdminApiFp(configuration).adminDeleteNftToken(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteOrganization(id, options) {
            return exports.AdminApiFp(configuration).adminDeleteOrganization(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteShow(id, options) {
            return exports.AdminApiFp(configuration).adminDeleteShow(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteVideoAsset(id, options) {
            return exports.AdminApiFp(configuration).adminDeleteVideoAsset(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {AdminEditShowRequestDTO} adminEditShowRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEditShow(id, adminEditShowRequestDTO, options) {
            return exports.AdminApiFp(configuration).adminEditShow(id, adminEditShowRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {IAddEventsBody} iAddEventsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSetAddEvents(id, iAddEventsBody, options) {
            return exports.AdminApiFp(configuration).adminEventSetAddEvents(id, iAddEventsBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {IRemoveEventsBody} iRemoveEventsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventSetRemoveEvents(id, iRemoveEventsBody, options) {
            return exports.AdminApiFp(configuration).adminEventSetRemoveEvents(id, iRemoveEventsBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEventSet(id, options) {
            return exports.AdminApiFp(configuration).adminGetEventSet(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEventStreamDetails(id, options) {
            return exports.AdminApiFp(configuration).adminGetEventStreamDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetIAPConfig(id, options) {
            return exports.AdminApiFp(configuration).adminGetIAPConfig(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetIAPPriceMap(options) {
            return exports.AdminApiFp(configuration).adminGetIAPPriceMap(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetOrganization(id, options) {
            return exports.AdminApiFp(configuration).adminGetOrganization(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetShow(id, options) {
            return exports.AdminApiFp(configuration).adminGetShow(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListAppleInAppPurchaseProduct(options) {
            return exports.AdminApiFp(configuration).adminListAppleInAppPurchaseProduct(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EventSetSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListEventSets(sortBy, sortOrder, startAfter, limit, options) {
            return exports.AdminApiFp(configuration).adminListEventSets(sortBy, sortOrder, startAfter, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [id]
         * @param {string} [eventId]
         * @param {EventIAPSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListIAPConfig(id, eventId, sortBy, sortOrder, startAfter, limit, options) {
            return exports.AdminApiFp(configuration).adminListIAPConfig(id, eventId, sortBy, sortOrder, startAfter, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrganizationSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {string} [name]
         * @param {string} [displayName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListOrganizations(sortBy, sortOrder, startAfter, limit, name, displayName, options) {
            return exports.AdminApiFp(configuration).adminListOrganizations(sortBy, sortOrder, startAfter, limit, name, displayName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [cobrand]
         * @param {string} [venueId]
         * @param {string} [artistId]
         * @param {string} [organizationId]
         * @param {Array<ShowType>} [type]
         * @param {string} [shopifyProductTag]
         * @param {string} [shopifyMerchTag]
         * @param {string} [muxId]
         * @param {boolean} [autoSchedule]
         * @param {Array<ShowState>} [state]
         * @param {string} [beforeDate]
         * @param {ShowSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {boolean} [excludePast] whether past shows should be included in the response. This parameter is incompatible with passing &#x60;sortBy&#x60; unless specific Firestore indices are created to support compound queries
         * @param {Array<AdminShowIncludes>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListShows(cobrand, venueId, artistId, organizationId, type, shopifyProductTag, shopifyMerchTag, muxId, autoSchedule, state, beforeDate, sortBy, sortOrder, startAfter, limit, excludePast, include, options) {
            return exports.AdminApiFp(configuration).adminListShows(cobrand, venueId, artistId, organizationId, type, shopifyProductTag, shopifyMerchTag, muxId, autoSchedule, state, beforeDate, sortBy, sortOrder, startAfter, limit, excludePast, include, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [managerId]
         * @param {string} [email]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 10000
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListShowsByManager(managerId, email, startAfter, limit, options) {
            return exports.AdminApiFp(configuration).adminListShowsByManager(managerId, email, startAfter, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {string} [eventId]
         * @param {string} [artistId]
         * @param {string} [venueId]
         * @param {string} [organizationId]
         * @param {string} [search]
         * @param {string} [tags]
         * @param {boolean} [videoAssetIsPublic]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListVideoAssets(startAfter, limit, eventId, artistId, venueId, organizationId, search, tags, videoAssetIsPublic, options) {
            return exports.AdminApiFp(configuration).adminListVideoAssets(startAfter, limit, eventId, artistId, venueId, organizationId, search, tags, videoAssetIsPublic, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InlineObject} inlineObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveIAPPriceMapItem(inlineObject, options) {
            return exports.AdminApiFp(configuration).adminRemoveIAPPriceMapItem(inlineObject, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {IUpdateEventStreamDetailsUseCase} iUpdateEventStreamDetailsUseCase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateEventStreamDetails(id, iUpdateEventStreamDetailsUseCase, options) {
            return exports.AdminApiFp(configuration).adminUpdateEventStreamDetails(id, iUpdateEventStreamDetailsUseCase, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {UpdateIAPConfigRequestDTO} updateIAPConfigRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateIAPConfig(id, updateIAPConfigRequestDTO, options) {
            return exports.AdminApiFp(configuration).adminUpdateIAPConfig(id, updateIAPConfigRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {AdminUpdateNftTokenRequestDTO} adminUpdateNftTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateNftToken(id, adminUpdateNftTokenRequestDTO, options) {
            return exports.AdminApiFp(configuration).adminUpdateNftToken(id, adminUpdateNftTokenRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {AdminUpdateOrganizationRequestDTO} adminUpdateOrganizationRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateOrganization(id, adminUpdateOrganizationRequestDTO, options) {
            return exports.AdminApiFp(configuration).adminUpdateOrganization(id, adminUpdateOrganizationRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UpdateVideoAssetRequest} updateVideoAssetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateVideoAsset(updateVideoAssetRequest, options) {
            return exports.AdminApiFp(configuration).adminUpdateVideoAsset(updateVideoAssetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allGenres(options) {
            return exports.AdminApiFp(configuration).allGenres(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateCsatSurveyRequestDTO} createCsatSurveyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurvey(createCsatSurveyRequestDTO, options) {
            return exports.AdminApiFp(configuration).createSurvey(createCsatSurveyRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} surveyIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalSurveyResponsesBySurveyId(surveyIdentifier, options) {
            return exports.AdminApiFp(configuration).generalSurveyResponsesBySurveyId(surveyIdentifier, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GenerateCustomTokenRequestDTO} generateCustomTokenRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCustomToken(generateCustomTokenRequestDTO, options) {
            return exports.AdminApiFp(configuration).generateCustomToken(generateCustomTokenRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubscriptionsByTopic(topic, options) {
            return exports.AdminApiFp(configuration).getAllSubscriptionsByTopic(topic, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} surveyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResponsesBySurveyId(surveyId, options) {
            return exports.AdminApiFp(configuration).getResponsesBySurveyId(surveyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} searchText
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpotifyArtists(searchText, options) {
            return exports.AdminApiFp(configuration).getSpotifyArtists(searchText, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CobrandSortKeys} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCobrands(sortBy, sortOrder, startAfter, limit, options) {
            return exports.AdminApiFp(configuration).listCobrands(sortBy, sortOrder, startAfter, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [siteId]
         * @param {string} [slug]
         * @param {string} [surveyIdentifier]
         * @param {SortOrder} [sortOrder]
         * @param {number} [limit] Maximum value: 5000
         * @param {string} [startAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveyReponses(siteId, slug, surveyIdentifier, sortOrder, limit, startAfter, options) {
            return exports.AdminApiFp(configuration).listSurveyReponses(siteId, slug, surveyIdentifier, sortOrder, limit, startAfter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CsatSurveySortBy} [sortBy]
         * @param {SortOrder} [sortOrder]
         * @param {string} [startAfter]
         * @param {number} [limit] Maximum value: 100
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSurveys(sortBy, sortOrder, startAfter, limit, options) {
            return exports.AdminApiFp(configuration).listSurveys(sortBy, sortOrder, startAfter, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MigrateApiKeyRequestDTO} migrateApiKeyRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateApiKey(migrateApiKeyRequestDTO, options) {
            return exports.AdminApiFp(configuration).migrateApiKey(migrateApiKeyRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminUploadNftAssetDTO} adminUploadNftAssetDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNftAsset(adminUploadNftAssetDTO, options) {
            return exports.AdminApiFp(configuration).uploadNftAsset(adminUploadNftAssetDTO, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
class AdminApi extends base_1.BaseAPI {
    /**
     *
     * @param {AdminApiAddSurveyToEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    addSurveyToEvent(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).addSurveyToEvent(requestParameters.createCsatSurveyEntryRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminAddIAPPriceMapItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminAddIAPPriceMapItem(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminAddIAPPriceMapItem(requestParameters.updateIAPPriceMapDTOItem, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminApprovePreRecordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminApprovePreRecord(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminApprovePreRecord(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminChangeShowStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminChangeShowState(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminChangeShowState(requestParameters.id, requestParameters.inlineObject1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminCreateEventSetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminCreateEventSet(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminCreateEventSet(requestParameters.iCreateEventSetBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminCreateEventStreamDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminCreateEventStreamDetails(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminCreateEventStreamDetails(requestParameters.adminCreateEventStreamDetailsRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminCreateGenreRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminCreateGenre(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminCreateGenre(requestParameters.createGenreRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminCreateIAPConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminCreateIAPConfig(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminCreateIAPConfig(requestParameters.createIAPConfigRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminCreateNftTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminCreateNftToken(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminCreateNftToken(requestParameters.adminCreateNftTokenRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminCreateOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminCreateOrganization(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminCreateOrganization(requestParameters.adminCreateOrganizationRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminCreateShowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminCreateShow(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminCreateShow(requestParameters.adminCreateShowRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminCreateVideoAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminCreateVideoAsset(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminCreateVideoAsset(requestParameters.createVideoAssetDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminCreateVideoAssetUploadUrl(options) {
        return exports.AdminApiFp(this.configuration).adminCreateVideoAssetUploadUrl(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminDeleteEventStreamDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminDeleteEventStreamDetails(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminDeleteEventStreamDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminDeleteGenreRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminDeleteGenre(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminDeleteGenre(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminDeleteIAPConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminDeleteIAPConfig(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminDeleteIAPConfig(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminDeleteNftTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminDeleteNftToken(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminDeleteNftToken(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminDeleteOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminDeleteOrganization(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminDeleteOrganization(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminDeleteShowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminDeleteShow(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminDeleteShow(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminDeleteVideoAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminDeleteVideoAsset(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminDeleteVideoAsset(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminEditShowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminEditShow(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminEditShow(requestParameters.id, requestParameters.adminEditShowRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminEventSetAddEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminEventSetAddEvents(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminEventSetAddEvents(requestParameters.id, requestParameters.iAddEventsBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminEventSetRemoveEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminEventSetRemoveEvents(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminEventSetRemoveEvents(requestParameters.id, requestParameters.iRemoveEventsBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminGetEventSetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminGetEventSet(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminGetEventSet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminGetEventStreamDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminGetEventStreamDetails(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminGetEventStreamDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminGetIAPConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminGetIAPConfig(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminGetIAPConfig(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminGetIAPPriceMap(options) {
        return exports.AdminApiFp(this.configuration).adminGetIAPPriceMap(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminGetOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminGetOrganization(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminGetOrganization(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminGetShowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminGetShow(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminGetShow(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminListAppleInAppPurchaseProduct(options) {
        return exports.AdminApiFp(this.configuration).adminListAppleInAppPurchaseProduct(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminListEventSetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminListEventSets(requestParameters = {}, options) {
        return exports.AdminApiFp(this.configuration).adminListEventSets(requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminListIAPConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminListIAPConfig(requestParameters = {}, options) {
        return exports.AdminApiFp(this.configuration).adminListIAPConfig(requestParameters.id, requestParameters.eventId, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminListOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminListOrganizations(requestParameters = {}, options) {
        return exports.AdminApiFp(this.configuration).adminListOrganizations(requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, requestParameters.name, requestParameters.displayName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminListShowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminListShows(requestParameters = {}, options) {
        return exports.AdminApiFp(this.configuration).adminListShows(requestParameters.cobrand, requestParameters.venueId, requestParameters.artistId, requestParameters.organizationId, requestParameters.type, requestParameters.shopifyProductTag, requestParameters.shopifyMerchTag, requestParameters.muxId, requestParameters.autoSchedule, requestParameters.state, requestParameters.beforeDate, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, requestParameters.excludePast, requestParameters.include, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminListShowsByManagerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminListShowsByManager(requestParameters = {}, options) {
        return exports.AdminApiFp(this.configuration).adminListShowsByManager(requestParameters.managerId, requestParameters.email, requestParameters.startAfter, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminListVideoAssetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminListVideoAssets(requestParameters = {}, options) {
        return exports.AdminApiFp(this.configuration).adminListVideoAssets(requestParameters.startAfter, requestParameters.limit, requestParameters.eventId, requestParameters.artistId, requestParameters.venueId, requestParameters.organizationId, requestParameters.search, requestParameters.tags, requestParameters.videoAssetIsPublic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminRemoveIAPPriceMapItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminRemoveIAPPriceMapItem(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminRemoveIAPPriceMapItem(requestParameters.inlineObject, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminUpdateEventStreamDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminUpdateEventStreamDetails(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminUpdateEventStreamDetails(requestParameters.id, requestParameters.iUpdateEventStreamDetailsUseCase, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminUpdateIAPConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminUpdateIAPConfig(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminUpdateIAPConfig(requestParameters.id, requestParameters.updateIAPConfigRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminUpdateNftTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminUpdateNftToken(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminUpdateNftToken(requestParameters.id, requestParameters.adminUpdateNftTokenRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminUpdateOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminUpdateOrganization(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminUpdateOrganization(requestParameters.id, requestParameters.adminUpdateOrganizationRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiAdminUpdateVideoAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminUpdateVideoAsset(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).adminUpdateVideoAsset(requestParameters.updateVideoAssetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    allGenres(options) {
        return exports.AdminApiFp(this.configuration).allGenres(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiCreateSurveyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    createSurvey(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).createSurvey(requestParameters.createCsatSurveyRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiGeneralSurveyResponsesBySurveyIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    generalSurveyResponsesBySurveyId(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).generalSurveyResponsesBySurveyId(requestParameters.surveyIdentifier, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiGenerateCustomTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    generateCustomToken(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).generateCustomToken(requestParameters.generateCustomTokenRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiGetAllSubscriptionsByTopicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    getAllSubscriptionsByTopic(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).getAllSubscriptionsByTopic(requestParameters.topic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiGetResponsesBySurveyIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    getResponsesBySurveyId(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).getResponsesBySurveyId(requestParameters.surveyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiGetSpotifyArtistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    getSpotifyArtists(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).getSpotifyArtists(requestParameters.searchText, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiListCobrandsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    listCobrands(requestParameters = {}, options) {
        return exports.AdminApiFp(this.configuration).listCobrands(requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiListSurveyReponsesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    listSurveyReponses(requestParameters = {}, options) {
        return exports.AdminApiFp(this.configuration).listSurveyReponses(requestParameters.siteId, requestParameters.slug, requestParameters.surveyIdentifier, requestParameters.sortOrder, requestParameters.limit, requestParameters.startAfter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiListSurveysRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    listSurveys(requestParameters = {}, options) {
        return exports.AdminApiFp(this.configuration).listSurveys(requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startAfter, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiMigrateApiKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    migrateApiKey(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).migrateApiKey(requestParameters.migrateApiKeyRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminApiUploadNftAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    uploadNftAsset(requestParameters, options) {
        return exports.AdminApiFp(this.configuration).uploadNftAsset(requestParameters.adminUploadNftAssetDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdminApi = AdminApi;
